import Vue, { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'

import './form.sass'

@Component
export class Form extends Vue {

  @Prop({ required: false, default: 'column' })
  direction: 'row' | 'column'

  @Prop({ required: false })
  submit: () => void

  render (h: CreateElement) {
    return <form class={'component-form ' + this.direction} onKeyup={(event: KeyboardEvent) => {
      if (event.keyCode === 13) {
        if (this.submit) {
          this.submit()
        }
      }
    }}>
      {
        this.$slots.default
      }
    </form>
  }

}
